<template>
    <v-container fluid>
        <!-- Search bar -->
        <v-row align="center">
            <!-- <v-col cols="6" class="text-left mb-2">
                <v-text-field v-model="search" label="Recherchez une entreprise" single-line
                    hide-details></v-text-field>
            </v-col> -->
            <v-col cols="12" class="text-right mb-2">
                <!-- Button to open add notice dialog -->
                <v-btn small color="primary" dark @click="openDialog">
                    <v-icon small class="mr-2">mdi-plus</v-icon>FAIRE UNE DEMANDE
                </v-btn>
            </v-col>
        </v-row>

        <!-- Dialog for adding new notice -->
        <v-dialog v-model="dialog" max-width="800px" persistent>
            <v-card>
                <v-card-title>
                    <h4 class="headline">{{ formTitle }}</h4>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="demandeQuitus.nomCabinet" label="Nom du cabinet"
                                hint="Nom du cabinet"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="demandeQuitus.nomPersonne" label="Nom de la personne à contacter"
                                hint="Nom de la personne à contacter"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field v-model="demandeQuitus.emailContact" label="Email du contact"
                                hint="Email du contact"></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="demandeQuitus.pieceJointeDemande" placeholder="Charger le fichier"
                                label="Joindre la fiche dûment rempli" multiple prepend-icon="mdi-paperclip">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                        <v-col cols="12">
                            <v-file-input v-model="demandeQuitus.pieceJointeJustificative"
                                placeholder="Charger le fichier" label="Joindre la pièce justificative" multiple
                                prepend-icon="mdi-paperclip">

                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="red darken-1" text @click="closeDialog">
                        ANNULER
                    </v-btn>
                    <v-btn small color="green darken-1" text @click="addDemande">
                        ENVOYER LA DEMANDE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Data table for displaying exclusions -->
        <v-data-table locale="fr" :headers="headers" :search="search" no-data-text="Aucune demande trouvée"
            :items="this.$store.getters['Auth/getDemandeQuitus']" @click:row="goto" class="elevation-1 mb-5 px-5">
            <!-- Slot for custom row rendering -->

            <template v-slot:[`item.dateDemande`]="{ item }">{{
                    item.dateDemande | moment("DD MMMM YYYY")
                }}</template>

            <template v-slot:[`item.status`]="{ item }">
                <v-chip label small outlined :color="getStatusColor(item.status)" text-color="white">{{ item.status
                    }}</v-chip>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import { mapActions } from "vuex";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
    components: { DatePicker },
    data: () => ({
        search: "",
        dialog: false,
        formTitle: "ENVOYER LA DEMANDE",
        demandeQuitus: {
            nomCabinet: '',
            nomPersonne: '',
            emailContact: '',
            pieceJointeDemande: null,
            pieceJointeJustificative: null
        },

        headers: [
            { text: "Nom du cabinet", align: "start", sortable: false, value: "nomCabinet" },
            { text: "Personne à contacter", sortable: false, value: "nomPersonne" },
            { text: "Email du contact", sortable: false, value: "emailContact" },
            { text: "Date de demande", sortable: false, value: "dateDemande" },
            { text: "Status", sortable: false, value: "status" },
        ],
    }),
    created() {
        this.$store.dispatch("Auth/loadAllDemandeQuitusByUser");
        this.$store.dispatch("Auth/getData");
    },
    methods: {
        ...mapActions({
            loadAllDemandeQuitus: "Auth/loadAllDemandeQuitusByUser",
            sendDemande: "Auth/addDemandeQuitus"
        }),
        getStatusColor(status) {
            switch (status) {
                case 'Délivrée':
                    return 'green--text';
                case 'Rejetée':
                    return 'red--text';
                case 'En_Cours':
                    return 'blue--text';
                default:
                    return '';
            }
        },
        openDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        },
        goto(value) {
            const { id } = value;
            this.$router.push({ name: "show_quitus_non_redevance", params: { id: id } });
        },
        addDemande() {
            const data = new FormData();
            data.append("nomCabinet", this.demandeQuitus.nomCabinet);
            data.append("nomPersonne", this.demandeQuitus.nomPersonne);
            data.append("emailContact", this.demandeQuitus.emailContact);
            if (this.demandeQuitus.pieceJointeDemande) {
                data.append("pieceJointeDemande", this.demandeQuitus.pieceJointeDemande[0]);
            } else {
                data.append("pieceJointeDemande", null);
            }

            if (this.demandeQuitus.pieceJointeJustificative) {
                data.append("pieceJointeJustificative", this.demandeQuitus.pieceJointeJustificative[0]);
            } else {
                data.append("pieceJointeJustificative", null);
            }

            this.sendDemande(data);

            this.demandeQuitus.nomCabinet = "";
            this.demandeQuitus.nomPersonne = "";
            this.demandeQuitus.emailContact = "";
            this.demandeQuitus.pieceJointeDemande = "";
            this.demandeQuitus.pieceJointeJustificative = "";

            this.dialog = false;
        },

    }
};
</script>

<style></style>